
import { useEffect } from 'react'
import Select from 'react-select'
import { STPEnergyMPCNoDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const STPEnergyMPCNoDataDDL = (props) => {
    const { EnergyMPCNo, setEnergyMPCNo, WardName, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            // M_STP_UnitTypeID: UnitType.ID,
        }
        // if (UnitType.ID) {
        dispatch(STPEnergyMPCNoDDLAPI({ data }))
        // }
    }, [IsPost,WardName.ID])

    const { STPEnergyMPCNoData } = useSelector(state => state.STPEnergyMPCNoDDL)

    useEffect(() => {
        handleSTPEnergyMPCNoDDL()
    }, [STPEnergyMPCNoData])

    const handleSTPEnergyMPCNoDDL = () => {
        // console.log(DeptDDLDataa)
        if (STPEnergyMPCNoData && STPEnergyMPCNoData.table && STPEnergyMPCNoData.table.length > 0) {
            let list = STPEnergyMPCNoData.table.map((item, index) => ({
                value: item.m_stP_EnergyMPCNoID,
                label: item.energyMPCNo,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setEnergyMPCNo({ ...EnergyMPCNo, DDL: list })
        }
        else {
            setEnergyMPCNo({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Energy MPC No </b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: EnergyMPCNo.ID, label: EnergyMPCNo.Label }}
                onChange={(e) => {
                    e ?
                        setEnergyMPCNo({ ...EnergyMPCNo, ID: e.value, Label: e.label })
                        :
                        setEnergyMPCNo({ ...EnergyMPCNo, ID: 0, Label: "Select..." })

                }}
                options={EnergyMPCNo.DDL}
            />
        </div>
    )
}